"use strict";

const relations = {
    supportsRight: { codePoint: 8594 },
    supportsLeft: { codePoint: 8592 },
    objects: { codePoint: 10539 },
    equals: { codePoint: 65309 },
    notEquals: { codePoint: 8800, deprecated: true },
    connection: { codePoint: 8212 },
    question: { codePoint: 65311, deprecated: false },
    afterRight: { codePoint: 8605 },
    afterLeft: { codePoint: 8604 },
    weakensRight: { codePoint: 8674 },
    weakensLeft: { codePoint: 8672 },
    closedLoop: { codePoint: 8621 },
};

Object.keys(relations).forEach((name) => {
    module.exports[name] = name;
});

function getCodePoint(name) {
    if (relations[name] == null) {
        throw new Error("Invalid relation name: " + name);
    } else {
        return relations[name].codePoint;
    }
}

module.exports.getCodePoint = getCodePoint;

function getSymbol(name) {
    return String.fromCodePoint(getCodePoint(name));
}

module.exports.getSymbol = getSymbol;

module.exports.isRelationSymbol = function (text) {
    return Object.keys(relations).find((name) => getSymbol(name) == text) != null;
};

module.exports.invert = function (relation) {
    switch (relation) {
        case relations.supportsRight:
            return supportsLeft;
        case relations.supportsLeft:
            return supportsRight;
        case relations.afterRight:
            return afterLeft;
        case relations.afterLeft:
            return afterRight;
        case relations.weakensRight:
            return weakensLeft;
        case relations.weakensLeft:
            return weakensRight;
        default:
            return relation;
    }
};

module.exports.forEachRelation = function (action) {
    Object.keys(relations)
        .filter((relation) => relations[relation].deprecated != true)
        .forEach(action);
};
